import axios from "axios";
import { ElMessage, ElNotification } from "element-plus";
import { useUserStore } from "@/stores/modules/user";
import { useAuthStore } from "@/stores/modules/auth";
import router from "@/routers/index";
// create an axios instance
const service: any = axios.create({
  baseURL: import.meta.env.VITE_API_URL, // url = base url + request url
  timeout: 20000, // request timeout
  headers: {
    "Cache-Control": "no-cache", //禁止从缓存读取
    Pragma: "no-cache"
  }
});

// request interceptor
service.interceptors.request.use(
  (config: any) => {
    const authStore = useAuthStore();
    config.headers["Authorization"] = authStore.token;
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// response interceptors
service.interceptors.response.use(
  (response: any) => {
    const res: any = response.data;
    const status = response.status;
    if (res.code) {
      if (res.code === 200) {
        return res;
      } else {
        if (res.code === 401) {
          ElMessage({
            message: res.message,
            type: "error",
            duration: 2 * 1000
          });
          const userStore = useUserStore();
          const authStore = useAuthStore();
          authStore.token = "";
          userStore.setUserInfo({ id: "", userName: "", phone: "", inviteCode: "", status: 0, ownerType: 1, verifyStatus: 1 });

          router.push("/login");
        }
        if (res.code === 400) {
          ElNotification({
            title: "错误",
            message: res.message,
            type: "error"
          });
          return Promise.reject(new Error(res.message || "Error"));
        }
        if (res.code === 403) {
          router.replace("/403");
          return Promise.reject(new Error(res.message || "Error"));
        }
        if (res.code === 500) {
          ElNotification({
            title: "错误",
            message: res.message,
            type: "error"
          });
          return Promise.reject(new Error(res.message || "Error"));
        }
        if (res.code === 5001) {
          return res;
        }
        if (res.code === 5002) {
          ElMessage({
            message: res.message,
            type: "error"
          });
          //   return Promise.reject(new Error(res.message || "Error"));
          return Promise.reject(new Error(res.message || "Error"));
        }
        if (res.code === 5101) {
          return res;
        }
      }
    } else {
      if (status === 500) {
        return Promise.reject(new Error(res.message || "Error"));
      } else {
        // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
        return res;
      }
    }
  },
  (error: any) => {
    ElMessage({
      message: error,
      type: "error",
      duration: 2 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
